import "./DashboardCard.css";
import { FormattedMessage } from "react-intl";

const DashboardCard = (props: any) => {
  return (
    <div className="dashboard-card-container">
      <div className="card-dashboard float-right">
        <div className="row">
          <div className="col-sm-6">
            <img className="card-dashboard-image" src={props.img} alt="" />
          </div>
          <div className="col-sm-6">
            <div className="">
              <h4 className="dashboard-search-h4">{props.title}</h4>
              <p className="dashboard-percentage-p">{props.percentage}</p>
              <div className="container dashboard-stats-card">
                <div className="row">
                  <div className="col dashboard-stats-col">
                    <FormattedMessage id="ready-size-age" />:{" "}
                    <div className="dashboard-stat-number">{props.edad}</div>
                  </div>
                  <div className="col dashboard-stats-col">
                    <FormattedMessage id="ready-size-weight" />:{" "}
                    <div className="dashboard-stat-number">{props.peso}</div>{" "}
                  </div>
                </div>
                <div className="row">
                  <div className="col dashboard-stats-col">
                    <FormattedMessage id="ready-size-height" />:
                    <div className="dashboard-stat-number">{props.altura}</div>{" "}
                  </div>
                  <div className="col dashboard-stats-col">
                    <FormattedMessage id="ready-size-length" />:
                    <div className="dashboard-stat-number">{props.largo}</div>
                  </div>
                </div>
                <div className="row">
                  <div className="col dashboard-stats-col">
                    <FormattedMessage id="ready-size-waist" />:
                    <div className="dashboard-stat-number">{props.cintura}</div>
                  </div>
                  <div className="col dashboard-stats-col">
                    <FormattedMessage id="ready-size-hip" />:
                    <div className="dashboard-stat-number">{props.cadera}</div>
                  </div>
                </div>
                <div className="row  dashboard-stats-col-row">
                  <div className="col-md-6 dashboard-stats-col">
                    <FormattedMessage id="ready-size-bust" />:
                    <div className="dashboard-stat-number-left">
                      {props.busto}
                    </div>
                  </div>
                </div>
                <div className="row  dashboard-stats-col-row">
                  <div className="col-md-6 dashboard-stats-col">
                    <FormattedMessage id="ready-size-feetlength" />:
                    <div className="dashboard-stat-number-left">
                      {props.largoPie}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardCard;
